<template>
  <div
    class="padding-10 border item-cursor"
    @click="onOfficeSelected">
    <weex-text class="font-weight-bold font-size-sm-base">{{ getOfficeName }}</weex-text>
    <weex-text class="font-size-sm-base margin-top-5">{{ getOfficeAddress }}</weex-text>
  </div>
</template>

<script>

  import EzUtils from "../../utils/EzUtils";

  export default {
    name: "OfficeItem",
    props: {
      officeDetails: {
        type: Object,
        required: true,
        default: () => ({})
      },

    },

    methods: {
      onOfficeSelected() {
        this.$emit("onOfficeSelected", this.officeDetails)
      }
    },

    computed: {
      getOfficeName() {
        return this.officeDetails && this.officeDetails.office && this.officeDetails.office.name
          ? this.officeDetails.office.name
          : "";
      },

      getOfficeAddress() {
        return this.officeDetails && this.officeDetails.address
          ? EzUtils.getHumanReadableAddress(this.officeDetails.address)
          : "";
      }
    }
  };
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>
